import GeLabel from '@features/GeLabel/ui/GeLabel';

export default function GeLabelPage() {
  return <GeLabel />;
}
